module.exports = __webpack_public_path__ + "img/Bezael_Perez.d0fb38cb.jpg";